import { createRoute } from "@tanstack/react-router";
import { BenchmarkSettings } from "@/components/marketing/benchmark-settings";
import { PageHeader } from "@/components/shared/page-header";
import { Route as authenticatedRoute } from "../_authenticated";

function MarketingBenchmarksPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Marketing Benchmarks"
        description="Targets that drive the 🟢🟡🔴 grading across every marketing page. Edits save automatically."
      />
      <BenchmarkSettings />
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/marketing/benchmarks",
  component: MarketingBenchmarksPage,
});
